export class InvoiceData {
    constructor(addr, amount = 0, message = "", type = 2) {
        this.address = addr.split('-').join('');
        this.amount = amount;
        this.message = message;
        this.type = type;
    }
    static fromJsonString(jsonString) {
        try {
            const json = JSON.parse(jsonString);
            const type = json.type;
            if (json.v != 2 || ((type != 1) && (type != 2))) {
                return null;
            }
            const address = json.data.addr;
            if (!address || address.length === 0) {
                return null;
            }
            const amount = json.data.amount || 0;
            const message = json.data.msg || "";
            return new InvoiceData(address, amount, message, type);
        }
        catch (e) {
            return null;
        }
    }
    toJsonString() {
        const json = {
            v: 2,
            type: this.type,
            data: {
                name: "",
                addr: this.address,
                amount: this.amount,
                msg: this.message
            }
        };
        return JSON.stringify(json);
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/lib/invoiceData.ts
// module id = 184
// module chunks = 1